import { PublicCallback } from 'globals/types';
import { validateEventType } from 'core_main/globals/events';
import { KustomerEventTypes } from 'core_main/types';
import { removeListenerFromStore } from 'core_main/store';

export const removeListener = (
  type: KustomerEventTypes,
  cb?: PublicCallback,
) => {
  const isEventValid = validateEventType(type);

  if (isEventValid === false) return;

  if (typeof cb === 'function') {
    removeListenerFromStore(type, cb);
  }
};
